import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "newsletterCheckbox", "newsletterEmail",
    "emailNotificationsCheckbox", "notificationItem"
  ]

  static values = { userEmail: String }

  connect() {
    this._syncNewsletter()
    this._syncNotifications()
  }

  toggleNewsletter() {
    const checked = this.newsletterCheckboxTarget.checked
    this.newsletterEmailTarget.disabled = !checked

    if (checked && !this.newsletterEmailTarget.value.trim()) {
      this.newsletterEmailTarget.value = this.userEmailValue
    }
  }

  toggleNotifications() {
    this._syncNotifications()
  }

  _syncNewsletter() {
    this.newsletterEmailTarget.disabled = !this.newsletterCheckboxTarget.checked
  }

  _syncNotifications() {
    const enabled = this.emailNotificationsCheckboxTarget.checked
    this.notificationItemTargets.forEach(el => { el.disabled = !enabled })
  }
}
